import { render } from "./defaultTemplate.vue?vue&type=template&id=5cb0f2ec"
import script from "./defaultTemplate.vue?vue&type=script&lang=js"
export * from "./defaultTemplate.vue?vue&type=script&lang=js"

import "./defaultTemplate.vue?vue&type=style&index=0&id=5cb0f2ec&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__